import * as React from 'react';
import { randomId } from './util';

export default function CheckboxAdvanced({field, formControls, setFormControls, onChange=undefined, fontSize=undefined, fontWeight="400"}){
    let id=randomId()

    const [validity, setValidity] = React.useState({valid:true, warning:""})
    
    const handleFieldChange = (e) => {
	console.log("CHECKBOX STATE", formControls);

	setFormControls((prevState)=>{
	    if(field.disabled){
		return prevState;
	    }
	    if(prevState[field.name].value==1){
		prevState[field.name].value=0
	    } else {
		prevState[field.name].value=1
	    }

	    return prevState
	})
	    
    }
    
    return (
        <div className="checkbox-element">
            <span><input key={id} disabled={field.disabled} defaultChecked={formControls[field.name].value==1} onChange={handleFieldChange} className="checkbox-box" type="checkbox" id={id}/></span>
            <span><label style={{fontSize:fontSize, fontWeight:fontWeight}} className="checkbox-label" htmlFor={id}>{field.label}</label></span>
        </div>
    )
}
